import { themeGet, scrollbar } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const DrawerContainer = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
`;
export const ScrollContainer = styled.div `
  flex: 1;
  overflow-y: auto;
`;
export const ListContainer = styled.div `
  flex: 1;
  padding: ${themeGet('spacing.xl')};
  ${scrollbar({ trackMargin: 'xl' })};
  overflow-y: auto;
`;
